import { View, Pressable } from 'react-native'
import useRWD from '@ui/theme/useRWD'
import useAnimatedPress from '@ui/animated/useAnimatedPress'
import { OutlineAnimated } from '@ui/elements/Outline'

import { PackagePointsTileProps as Props } from './types'
import { borderRadius, colorOutline } from '@order/Package/styles'
import Head from '@order/Package/Head'
import Card from './Card'
import Bottom from './Bottom'
import Border from '@ui/effects/Border'

export default function PackagePointsTile(props: Props) {
  const {
    tier = 'default',
    points,
    image,
    imageText,
    imageProps,
    title,
    isRecommended,
    price,
    discount,
    onPress,
  } = props

  const { animation, onPressIn, onPressOut } = useAnimatedPress()
  const { tiles } = useRWD()
  const width = tiles.option.width
  const height = tiles.option.height

  return (
    <Pressable
      onPress={onPress}
      onPressIn={onPressIn}
      onPressOut={onPressOut}
      style={{ width, height }}
    >
      <View
        className="relative"
        style={{
          width,
          height,
        }}
      >
        {isRecommended && (
          <OutlineAnimated
            size={4}
            borderRadius={borderRadius}
            color={colorOutline[tier]}
          />
        )}
        <View
          className="flex h-full flex-col overflow-hidden"
          style={{ borderRadius }}
        >
          <Head size="small" title={title} tier={tier} />
          <Card
            width={width}
            height={height}
            tier={tier}
            points={points}
            image={image}
            imageProps={imageProps}
            imageText={imageText}
            discount={discount}
            animation={animation}
          />
          <Bottom tier={tier} price={price} discount={discount} />
          <Border style={{ borderRadius }} />
        </View>
      </View>
    </Pressable>
  )
}
